const doc = [({"da":({"js":({"admin":({"contacts":({"show":({"historical_data_card":({"historical_data":"Historisk data"})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;